/**
 * Cursor config writer
 *
 * Skill: ~/.agents/skills/sailfish-autofix/ (cross-client) + ~/.cursor/skills/
 * MCP: ~/.cursor/mcp.json mcpServers.sailfishAutofix
 */

import { homedir } from "os";
import { join } from "path";
import type { AgentConfigWriter } from "./base.js";
import { copySkillTo, removeSkillFrom, installCrossClientSkill, removeCrossClientSkill, buildMcpEntry, mutateJsonFile } from "./base.js";
import { MCP_SERVER_NAME } from "../constants.js";

const CURSOR_SKILLS_DIR = join(homedir(), ".cursor", "skills");
const CURSOR_MCP_CONFIG = join(homedir(), ".cursor", "mcp.json");

export const cursor: AgentConfigWriter = {
  id: "cursor",
  name: "Cursor",

  installSkill(global: boolean) {
    installCrossClientSkill(global);
    copySkillTo(CURSOR_SKILLS_DIR);
  },

  installMcp() {
    mutateJsonFile(CURSOR_MCP_CONFIG, (config) => {
      if (!config.mcpServers) config.mcpServers = {};
      config.mcpServers[MCP_SERVER_NAME] = buildMcpEntry();
      return config;
    });
  },

  uninstallSkill() {
    removeCrossClientSkill(true);
    removeSkillFrom(CURSOR_SKILLS_DIR);
  },

  uninstallMcp() {
    mutateJsonFile(CURSOR_MCP_CONFIG, (config) => {
      if (config.mcpServers?.[MCP_SERVER_NAME]) {
        delete config.mcpServers[MCP_SERVER_NAME];
      }
      return config;
    }, false);
  },
};
